// extracted by mini-css-extract-plugin
export default {"movableVideoCard":"iOuNr","overlay":"cR6zT","preview":"H13nw","dragged":"QGKvg","obsolete":"AbmqY","dragged__overlay":"Ss274"};